import React from 'react';
import { Box, Loader } from '@wix/design-system';
import styles from './InitialLoader.scss';
export function InitialLoader() {
  return /*#__PURE__*/React.createElement(Box, {
    className: styles.container,
    direction: "vertical",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Loader, null));
}
//# sourceMappingURL=InitialLoader.js.map